/**
 * Convert Updateable CalculationType to saveable calculationType to be updated/saved
 */
export default function toSaveableCalculationType(calculationType: string): string {
  switch (calculationType) {
    case 'amountPerHour':
      return 'value_per_hour'
    case 'pricePerAmount':
      return 'price_per_value'
    case 'hoursPerAmount':
      return 'hours_per_value'
    case 'amountPerPrice':
      return 'value_per_price'
    default:
      return calculationType
  }
}
